// extracted by mini-css-extract-plugin
module.exports = {"keyboard":"keyboard_keyboard__1BgHm","key":"keyboard_key__Rs-8Y","white":"keyboard_white__2d95u","blackWrapper":"keyboard_blackWrapper__1ft8U","black":"keyboard_black__2cYiD"};